import { Clock, CheckCircle } from '@emotion-icons/bootstrap';
import { differenceInDays, format, parseISO } from 'date-fns';
import { ColorType } from '~/types';
import { IListInvoice } from '~/types/invoice';

interface StatusResult {
  icon: typeof Clock | typeof CheckCircle | null;
  label: string;
  color: ColorType;
}

export const getInvoiceStatus = ({
  payment_status,
  payment_due_status,
  paid_date,
  due_date,
}: IListInvoice): StatusResult => {
  if (payment_status !== 'Paid') {
    if (!due_date) {
      return {
        icon: null,
        label: '',
        color: 'neutral',
      };
    }

    const dueDateObj = parseISO(due_date);
    const overdueDays = differenceInDays(new Date(), dueDateObj);
    const dueInDays = differenceInDays(dueDateObj, new Date());

    if (payment_due_status === 'Overdue') {
      return {
        icon: Clock,
        label: `Overdue ${overdueDays}d`,
        color: 'danger',
      };
    } else {
      return {
        icon: Clock,
        label: `Due in ${dueInDays}d`,
        color: 'neutral',
      };
    }
  }

  if (payment_status === 'Paid') {
    if (paid_date) {
      return {
        icon: CheckCircle,
        label: `Paid on ${format(parseISO(paid_date), 'dd MMM yyyy')}`,
        color: 'success',
      };
    } else {
      return {
        icon: CheckCircle,
        label: 'Paid',
        color: 'success',
      };
    }
  }

  return {
    icon: Clock,
    label: 'Unknown',
    color: 'primary',
  };
};
